webpackJsonp([26,33],{

/***/ 561:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Page404'
	};

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(561)
	
	/* template */
	var __vue_template__ = __webpack_require__(861)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 861:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-error-404"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_vm._m(1), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-home fa-lg"
	  }), _vm._v(" voltar para a Home\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "jumbotron text-center"
	  }, [_c('div', [_c('h3', [_vm._v("Ops! Página não encontrada.")]), _vm._v(" "), _c('h1', [_vm._v("404")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('strong', {
	    staticClass: "brand"
	  }, [_vm._v("loca"), _c('span', [_vm._v(".")]), _vm._v("shop")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.23b3a503f6c2f7c4c250.js